import {
  flexRender,
  Header,
  type Table as ReactTable,
} from '@tanstack/react-table';
import { cn } from '@sib/ui';
import {
  DataTableHeaderRow,
  getColumnGroupBorderClassName,
  getDataTableHeaderCellClassName,
  getDataTableHeaderCellStyle,
  getGroupHeaderColumnBorderSides,
} from './DataTableColumnGroupHeader.utils';

export interface DataTableColumnGroupHeaderCellProps<T> {
  header: Header<T, unknown>;
  table: ReactTable<T>;
  withFixedColumnWidth?: boolean;
  isFirstInRow?: boolean;
  hideRounding?: boolean;
}

export const DataTableColumnGroupHeaderCell = <T,>({
  header,
  table,
  withFixedColumnWidth = false,
  isFirstInRow = false,
  hideRounding = false,
}: DataTableColumnGroupHeaderCellProps<T>) => {
  const { hasStartBorder, hasEndBorder } = getGroupHeaderColumnBorderSides(
    header.column,
    table
  );

  return (
    <th
      colSpan={header.colSpan}
      role="columnheader"
      className={cn(
        'box-border overflow-visible border-0 px-3 text-left align-middle text-sm font-normal text-white',
        'h-(--data-table-group-header-height,2.25rem)',
        getDataTableHeaderCellClassName({
          header,
          row: DataTableHeaderRow.Group,
          withFixedColumnWidth,
        }),
        getColumnGroupBorderClassName({ hasStartBorder, hasEndBorder }),
        header.isPlaceholder && 'p-0 before:hidden after:hidden',
        isFirstInRow && !hideRounding && 'rounded-tl-md'
      )}
      style={getDataTableHeaderCellStyle(header)}
    >
      {!header.isPlaceholder &&
        flexRender(header.column.columnDef.header, header.getContext())}
    </th>
  );
};
